import { _ as _extends } from '../../_rollupPluginBabelHelpers-c245b26a.js';
import { forwardRef } from 'react';
import { themed } from '@indeed/ifl-css';
import { jsx } from '@emotion/react';

const ThemedInteractiveList = /*#__PURE__*/themed("ul", process.env.NODE_ENV === "production" ? {
  target: "e1kyujov0"
} : {
  target: "e1kyujov0",
  label: "ThemedInteractiveList"
})(() => ({
  boxSizing: "border-box",
  fontFamily: "default",
  lineHeight: "normal",
  isolation: "isolate",
  margin: 0,
  padding: 0,
  textIndent: 0,
  listStyleType: "none"
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkludGVyYWN0aXZlTGlzdC50c3giXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBSThCIiwiZmlsZSI6IkludGVyYWN0aXZlTGlzdC50c3giLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgUmVhY3QsIHsgZm9yd2FyZFJlZiB9IGZyb20gXCJyZWFjdFwiO1xuaW1wb3J0IHsgdGhlbWVkIH0gZnJvbSBcIkBpbmRlZWQvaWZsLWNzc1wiO1xuaW1wb3J0IHsgSW50ZXJhY3RpdmVMaXN0UHJvcHMgfSBmcm9tIFwiLi90eXBlc1wiO1xuXG5jb25zdCBUaGVtZWRJbnRlcmFjdGl2ZUxpc3QgPSB0aGVtZWQudWw8SW50ZXJhY3RpdmVMaXN0UHJvcHM+KCgpID0+ICh7XG4gIGJveFNpemluZzogXCJib3JkZXItYm94XCIsXG4gIGZvbnRGYW1pbHk6IFwiZGVmYXVsdFwiLFxuICBsaW5lSGVpZ2h0OiBcIm5vcm1hbFwiLFxuICBpc29sYXRpb246IFwiaXNvbGF0ZVwiLFxuICBtYXJnaW46IDAsXG4gIHBhZGRpbmc6IDAsXG4gIHRleHRJbmRlbnQ6IDAsXG4gIGxpc3RTdHlsZVR5cGU6IFwibm9uZVwiXG59KSk7XG5cbi8qKlxuICogQHNlZSBodHRwczovL2V4cGVyaWVuY2UuaW5kZWVkLmRlc2lnbi9jb21wb25lbnRzL2lkcy9pbnRlcmFjdGl2ZS1saXN0XG4gKi9cbmV4cG9ydCBjb25zdCBJbnRlcmFjdGl2ZUxpc3QgPSBmb3J3YXJkUmVmPFxuICBIVE1MVUxpc3RFbGVtZW50LFxuICBJbnRlcmFjdGl2ZUxpc3RQcm9wc1xuPigocHJvcHMsIHJlZikgPT4ge1xuICBjb25zdCB7IGNoaWxkcmVuLCAuLi5yZW1haW5pbmdQcm9wcyB9ID0gcHJvcHM7XG5cbiAgcmV0dXJuIChcbiAgICA8VGhlbWVkSW50ZXJhY3RpdmVMaXN0IHJlZj17cmVmfSB7Li4ucmVtYWluaW5nUHJvcHN9PlxuICAgICAge2NoaWxkcmVufVxuICAgIDwvVGhlbWVkSW50ZXJhY3RpdmVMaXN0PlxuICApO1xufSk7XG5cbkludGVyYWN0aXZlTGlzdC5kaXNwbGF5TmFtZSA9IFwiSW50ZXJhY3RpdmVMaXN0XCI7XG4iXX0= */");

/**
 * @see https://experience.indeed.design/components/ids/interactive-list
 */
const InteractiveList = /*#__PURE__*/forwardRef((props, ref) => {
  const {
    children,
    ...remainingProps
  } = props;
  return jsx(ThemedInteractiveList, _extends({
    ref: ref
  }, remainingProps), children);
});
InteractiveList.displayName = "InteractiveList";

export { InteractiveList };
